import Vue from 'vue'
import Router from 'vue-router'
import App from '../App.vue'
import mainBody from '@/components/mainBody'

Vue.use(Router)
export default new Router({
    routes: [
        {
            path: '/',
            name: 'mainBody',
            component: mainBody
        },
    ]
})
